import { appendVueRoute, getPath, Role } from '@therame/shared';
import { type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@stores/authStore';
import { useFeatureToggleStore } from '@stores/featureToggleStore';

const appointmentRoutes: Array<RouteRecordRaw> = [
  {
    ...appendVueRoute<'appointmentOverview'>('appointmentOverview', '/appointments/overview'),
    component: () => import('@src/views/AppointmentOverview/AppointmentOverview.vue'),
    meta: {
      layout: 'default',
      title: 'Termine',
      requiresAuth: true,
      requiresOnboarding: true,
      noPadding: true,
      transparentContent: true,
      accessPossibleWithRoles: [Role.PATIENT],
    },
    // The whole feature is behind a per-office-location toggle that defaults
    // off (TM-9436). Gate the route as well as the menu entry so a direct
    // deep-link can't reach it while the practice hasn't opted in. Await the
    // toggle load first — on a cold deep-link it may still be in flight from
    // the auth bootstrap, and a premature read would bounce the patient.
    beforeEnter: async () => {
      const authStore = useAuthStore();
      const featureToggleStore = useFeatureToggleStore();
      const officeLocationId = authStore.authContext?.user?.currentOfficeLocationId;
      if (officeLocationId) {
        await featureToggleStore.loadFeatureToggles(officeLocationId);
      }
      if (!featureToggleStore.isPatientAppointmentsEnabled) {
        return getPath<'home'>('/', {});
      }
      return true;
    },
  },
];

export default appointmentRoutes;
